module.exports = __webpack_public_path__ + "img/errorImage.2094ec8d.png";